import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/supabase.config';

/**
 * Whether an election is linked to the event. The "Habilitado para votar" controls
 * (participants list, registration desk) only show when it is.
 */
export function useEventHasVoting(eventId: string | undefined): boolean {
  const { data } = useQuery({
    queryKey: ['event_has_voting', eventId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('event_has_voting', { p_event_id: eventId as string });
      if (error) throw error;
      return data === true;
    },
    enabled: !!eventId,
    staleTime: 60_000,
  });
  return data === true;
}
